import React from 'react';
import Center from './Center';
import p1 from '../..//static/meetainImage.png';
import { Row, Col, Typography } from 'antd';
import { StyleSheet, css } from 'aphrodite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAppleAlt } from '@fortawesome/free-solid-svg-icons';
import { faLaughBeam } from '@fortawesome/free-solid-svg-icons';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { faUserFriends } from '@fortawesome/free-solid-svg-icons';

let styles = StyleSheet.create({
	background: {
		background: '#fff',
		textAlign: 'center',
		color: '#fff',
		padding: '5%',
	},
	h2: {
		fontSize: 'min(36px,3vw)',
	},
	p: {
		fontSize: 'min(16px,1vw)',
		color: 'gray',
	},
	img: {
		height: 'auto',
		width: 'min(600px,30vw)',
	},
});
const Intro3 = () => {
	let info = (title: string, paragraph: string, icon: any) => {
		return (
			<Col span={24}>
				<FontAwesomeIcon icon={icon} style={{ color: 'black', fontSize: '3vw' }} />
				<Typography.Title>{title}</Typography.Title>
				<Typography.Text type={'secondary'}>{paragraph}</Typography.Text>
			</Col>
		);
	};
	return (
		<>
			<div className={css(styles.background)}>
				<Center>
					<Typography.Title>Play online, Unlimited Fun</Typography.Title>
					<Typography.Text type={'secondary'}>Check out what you can do with this game!</Typography.Text>
					<br />
				</Center>
				<Row justify={'center'}>
					<Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
						<Row gutter={[16, 16]}>
							{info('IOS', 'Meetain support iphone and ipad devices', faAppleAlt)}
							{info('Fun to play', 'Meetain is such an addictive card games', faLaughBeam)}
							{info('Free to play', 'As always, this game is free to download', faDollarSign)}
							{info('Multiplayer', 'The game support Online Multiplayer', faUserFriends)}
						</Row>
					</Col>

					<Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
						{/* <img src={p1} alt="" className={css(styles.img)} /> */}
						<img src={p1} className={css(styles.img)} />
					</Col>
				</Row>
			</div>
		</>
	);
};

export default Intro3;
